var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bgfunds-content content-panel"},[_c('FundAside',{attrs:{"groups":_vm.asidePanelGroups,"debug":_vm.debug}}),_vm._v(" "),_c('FundMain',{attrs:{"groups":_vm.mainPanelGroups,"debug":_vm.debug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }